module.exports = __webpack_public_path__ + "img/AU.e875a51e.svg";